import { render, staticRenderFns } from "./invite-person.vue?vue&type=template&id=cd7c5398&scoped=true&"
import script from "./invite-person.vue?vue&type=script&lang=js&"
export * from "./invite-person.vue?vue&type=script&lang=js&"
import style0 from "./invite-person.vue?vue&type=style&index=0&id=cd7c5398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7c5398",
  null
  
)

export default component.exports